import { createContext } from 'react';

import { StoredResourceTagsContextType } from './ResourceTagContext';

export const StoredResourceTagsContext = createContext<
  StoredResourceTagsContextType | undefined
>(undefined);
